
import { getBuilding, getBuildingProgramTime, getProgram, getDistrict, getDistrictDetail, checkRequestFormStartDateWarning } from '../api.js'
import { postCheckStudent } from '../api.js'
import { SETTINGS } from '../api/config.js'

import pageApiData from '../utils/pageApiData.js'
import notifications from '../notifications.js'

const [ _getBuildingFromServer, _getBuilding, _getBuildingSync, _getBuildingFromServerForce ] = pageApiData.createFunctions(getBuilding, 'Unable to get buildings from server.')
const [ _getProgramFromServer, _getProgram, _getProgramSync ] = pageApiData.createFunctions(getProgram, 'Unable to get programs from server.')
const [ _getDistrictFromServer, _getDistrict, _getDistrictSync ] = pageApiData.createFunctions(getDistrict, 'Unable to get districts from server.', function (code) { return elem => elem.code === code })

const _districtData = {}
const _buildingProgrameTimesData = {}

function _hereApiKey() {
  return SETTINGS.hereApiKey
}

function _getDistrictDetail(code) {
  if (_districtData[code] !== undefined) {
    return Promise.resolve(_districtData[code])
  }

  let getDistrictPromise = getDistrictDetail(code)
  return getDistrictPromise
    .then(response => {
      _districtData[code] = response.data
      return response.data
    })
    .catch(error => {
      notifications.pushError(`Unable to load district data with code ${code}: ${error.response.data}`, error)
    })
}

function _getAllDistrictForView(view) {
  let districtCodeList = view.getDistrict()

  let promiseList = districtCodeList.map(code => {
    return _getDistrict(code)
  })

  Promise.all(promiseList)
    .then(result => {
      let retVal = {}
      for (let n = 0; n < districtCodeList.length; ++n) {
        let code = districtCodeList[n]
        let districtData = result[n]

        retVal[code] = districtData
        _districtData[code] = districtData
      }
      return retVal
    })
}

function _getBuildingProgramTime(id) {
  return getBuildingProgramTime(id)
    .then(result => {
      let buildingProgramTimes = result.data
      _buildingProgrameTimesData[id] = buildingProgramTimes
      return buildingProgramTimes
    })
    .catch(error => {
      notifications.pushError(`Unable to get building program times from from server code: ${error.response.data}`, error)
    })
}

function _postCheckStudent(apiBody) {
  return postCheckStudent(apiBody)
    .then(response => {
      let status = response.status
      if (status === 200 || status === 202) {
        let suggestedStudents = (status === 200) ? [ response.data ] : response.data
        return suggestedStudents
      } else {
        notifications.pushError(response.statusText)
        throw new Error(response.statusText)
      }
    })
    .catch(error => {
      notifications.pushError(error.statusText, error)
    })
}

function _clearEmptyLatLong(obj) {
  if (!obj.latitude) {
    delete obj['latitude']
  }
  if (!obj.longitude) {
    delete obj['longitude']
  }
}

function _checkStartDateWarning(content) {
  return checkRequestFormStartDateWarning(content)
}

function _init() {
  // do nothing
}

_init()

export default {
  clearEmptyLatLong: _clearEmptyLatLong,
  checkStartDateWarning: _checkStartDateWarning,

  hereApiKey: _hereApiKey,

  getBuildingFromServer: _getBuildingFromServer,
  getBuilding: _getBuilding,
  getBuildingSync: _getBuildingSync,
  getBuildingFromServerForce: _getBuildingFromServerForce,
  getProgramFromServer: _getProgramFromServer,
  getProgram: _getProgram,
  getProgramSync: _getProgramSync,
  getDistrictFromServer: _getDistrictFromServer,
  getDistrict: _getDistrict,
  getDistrictSync: _getDistrictSync,

  getDistrictDetail: _getDistrictDetail,
  getAllDistrictForView: _getAllDistrictForView,
  getBuildingProgramTime: _getBuildingProgramTime,

  postCheckStudent: _postCheckStudent,
}
